export const darkTheme = {
  bg:               '#0d1117',
  bgCard:           'rgba(13,20,30,0.88)',
  bgCardSolid:      '#161d2a',
  bgInput:          'rgba(255,255,255,0.03)',
  bgInputFocus:     'rgba(5,150,105,0.07)',
  bgSidebar:        'rgba(10,16,24,0.97)',
  border:           'rgba(5,150,105,0.2)',
  borderInput:      'rgba(255,255,255,0.07)',
  borderInputFocus: 'rgba(5,150,105,0.5)',
  textPrimary:      '#e2e8f0',
  textSecondary:    '#64748b',
  textMuted:        '#334155',
  accent:           '#059669',
  accentLight:      '#10b981',
  accentGradient:   'linear-gradient(135deg, #059669, #10b981)',
  accentHover:      '#047857',
  success:          '#10b981',
  warning:          '#f59e0b',
  error:            '#ef4444',
  orbColor1:        'rgba(5,150,105,0.12)',
  orbColor2:        'rgba(16,185,129,0.08)',
  gridLine:         'rgba(255,255,255,0.03)',
  cardSolid2:       '#0f1923',
};

export const lightTheme = {
  bg:               '#F0FDF4',
  bgCard:           'rgba(255,255,255,0.97)',
  bgCardSolid:      '#ffffff',
  bgInput:          'rgba(0,0,0,0.03)',
  bgInputFocus:     'rgba(5,150,105,0.05)',
  bgSidebar:        'rgba(240,253,244,0.98)',
  border:           '#E5E7EB',
  borderInput:      'rgba(0,0,0,0.1)',
  borderInputFocus: 'rgba(5,150,105,0.4)',
  textPrimary:      '#0f172a',
  textSecondary:    '#475569',
  textMuted:        '#94a3b8',
  accent:           '#059669',
  accentLight:      '#10b981',
  accentGradient:   'linear-gradient(135deg, #059669, #10b981)',
  accentHover:      '#047857',
  success:          '#10b981',
  warning:          '#f59e0b',
  error:            '#ef4444',
  orbColor1:        'rgba(5,150,105,0.08)',
  orbColor2:        'rgba(16,185,129,0.06)',
  gridLine:         'rgba(0,0,0,0.04)',
  cardSolid2:       '#f0fdf4',
};
